import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import logo from '../../logo.png';
import './Login.css';
import ErrorMessage from '../ErrorMessage';
import api_url from "../../consts";
@inject('authStore')
@observer
class Login extends Component {
  handleUsernameChange = (e) => {
    this.props.authStore.setUsername(e.target.value);
  };

  handlePasswordChange = (e) => {
    this.props.authStore.setPassword(e.target.value);
  };
  handleLogin = (e) => {
    e.preventDefault();
    this.props.authStore.login();
  }
  render() {
    const { authStore } = this.props;
    let passwordReset;
    if (api_url.PWRESET !== null) {
      passwordReset = (
        <a href={api_url.PWRESET} target="_blank" rel="noopener noreferrer">Unohditko salasanasi?</a>
      );
    }

    return (
      <div className="login-wrapper">
        <span className="flex"></span>

        <div className="login-header">
          <img
            src={logo}
            className="login-logo"
            alt="Talousmobiili"
          />
          <h1 className="login-title">Talousmobiili</h1>
        </div>

        <div className="login-content padding-md">
          <form
            onSubmit={this.handleLogin}
            className="login-form"
          >
            <TextField
              className="login-field"
              name="username"
              label="Käyttäjätunnus"
              value={authStore.username}
              onChange={this.handleUsernameChange}
              fullWidth
              autoFocus
            />

            <TextField
              className="login-field"
              name="password"
              label="Salasana"
              value={authStore.password}
              onChange={this.handlePasswordChange}
              margin="normal"
              type="password"
              fullWidth
            />

            <div className="login-action">
              {
                authStore.loading ?
                  <CircularProgress size={70} /> :

                  <Button
                    color="primary"
                    type="submit"
                    className="login-submit"
                    variant="contained"
                    fullWidth
                  >
                    Kirjaudu
                </Button>
              }
            </div>

            <br></br>
            <ErrorMessage />
          </form>
        </div>

        {passwordReset}
        <span className="flex"></span>

        <Typography component={'span'} variant="body2" className="padding-sm">
          <a href="https://www.suonentieto.fi">Suonentieto Oy</a>
        </Typography>
      </div>
    );
  }
}

export default Login;
